import Axios from 'axios'
import strings from '@/strings'
import store from "../store";

const client = {
  getDesk4meUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE_DESK4ME
  },
  getClientIdDesk4me () {
    return store.getters['Client/clientIdDesk4Me']
  },
  getClients () {
    return Axios.get(`api/v1/clients`)
  },
  addClient (client) {
    return Axios.post(`api/v1/clients`, client)
  },
  editClient (client) {
    return Axios.put(`api/v1/clients`, client)
  },
  getClientDomains(){
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/domains`)
  },
  activateClient (clientId) {
    return Axios.patch(`api/v1/clients/${clientId}/activate`)
  },
  deactivateClient (clientId) {
    return Axios.patch(`api/v1/clients/${clientId}/deactivate`)
  },
  scheduleRemovalClient(clientId, obj) {
    return Axios.patch(`api/v1/clients/${clientId}/schedule-removal`, obj)
  },
  cancelRemovalClient(clientId) {
    return Axios.patch(`api/v1/clients/${clientId}/cancel-removal`)
  },
}

export default client
